import React from 'react';
import { ListProps as NativeListProps, List as NativeList, Theme, styled } from '@mui/material';

const CustomList = styled(NativeList)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridGap: 7,
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: '1fr',
  },
}));

type ListProps = NativeListProps;

const List: React.FC<ListProps> = ({ children, className, ...rest }) => {
  return (
    <CustomList className={className} {...rest}>
      {children}
    </CustomList>
  );
};

export default List;
